export default __webpack_public_path__ + "static/media/fibra.06c7ab57.png";